module.exports = __webpack_public_path__ + "img/space.137ebc94.jpg";